interface ShipmentAvgTimeProps {
  text?: string;
  iconHidden?: boolean;
  classes?: string;
}

export const OrderProcessingTime = ({ text, iconHidden, classes = '' }: ShipmentAvgTimeProps) => {
  if (!text) {
    return null;
  }

  const [prefix, value] = text.split('|');

  return (
    <div className={`shipment-avg-time ${classes || ''}`}>
      {!iconHidden && <img src="/icons/icn-shipping.svg" className="shipment-avg-time__icon" alt="activity" />}
      <div>
        <span className="shipment-avg-time__text">{prefix}</span>
        <span className="shipment-avg-time__value"> {value}</span>
      </div>
    </div>
  );
};
